export default __webpack_public_path__ + "static/media/G4PS_150.3dbbc1ed.jpg";